// Import de bibliotecas principais
import React, { Fragment } from 'react'

// Import de elementos de estilização, componentes gerais e de layout
import './Category.module.scss'

import { Link } from 'react-router-dom'

// Definição de Header e Footer utilizado no template
// Category.layout = { header: 'HeaderExtra' }
//

export function Category() {
	return (
		<Fragment>
			<Link to="/">IR PARA OUTRO</Link>
		</Fragment>
	)
}
